import { Editor } from "@craftjs/core";
import type { PropsWithChildren } from "react";
import { createElement } from "react";

import useTheme from "./themes/use-theme";

type CraftEditorProps = Omit<React.ComponentProps<typeof Editor>, "children">;

function ThemedCraftProvider({
  children,
  ...opts
}: PropsWithChildren<CraftEditorProps>) {
  const { currentTheme } = useTheme();

  return createElement(
    Editor,
    {
      ...opts,
      resolver: {
        ...currentTheme.blocks,
        ...(opts.resolver || {}),
      },
    },
    children
  );
}

export default ThemedCraftProvider;
